import * as React from "react";
import TextEditControl from "./baseControls/TextEditControl";
import {observer} from "mobx-react";
import EditStoreStaticField from "./EditStoreStaticField";
import {formatEuroValue} from "../reactUtils";

@observer
export class TotalCostsExclDepositDisplayControl extends React.Component {
    render() {
        return (
            <EditStoreStaticField
                component={TextEditControl}
                {...this.props}
                valueGetter={(editStore) => formatEuroValue(editStore.getValue("totalPriceExclDeposit"), false)}
                adornment={"€"}
                title={"Gesamtsumme exkl. Kaution"}
            />
        );
    }
}

@observer
export class TotalCostsInclDepositDisplayControl extends React.Component {
    render() {
        return (
            <EditStoreStaticField
                component={TextEditControl}
                {...this.props}
                valueGetter={(editStore) => formatEuroValue(editStore.getValue("totalPriceInclDeposit"), false)}
                adornment={"€"}
                title={"Gesamtsumme inkl. Kaution"}
            />
        );
    }
}